export { default } from '@/modules/contato/pages/identificacao/index'
